module.exports = __webpack_public_path__ + "static/media/supernatural.2ea11702.jpg";